import { isJumperForMeAssets } from '../utils/game/isJumperForMeAssets'

export const settings = {
  scene: 'doodle_jump',
  elf: isJumperForMeAssets()
    ? { width: 110, height: 156, framerate: 60 }
    : { width: 141, height: 66, framerate: 60 },
  elfUfo: isJumperForMeAssets()
    ? { width: 234, height: 151, framerate: 60 }
    : { width: 141, height: 66, framerate: 60 },
  platform: { width: 75, height: 17 },
  boosters: [
    { name: 'jetpack', timeout: 5 },
    { name: 'spring', timeout: 5 },
  ],
  bonuses: [
    { name: 'bonus_1', score: 1, chance: 0.2 },
    { name: 'bonus_2', score: 1, chance: 0.2 },
    { name: 'bonus_3', score: 1, chance: 0.2 },
    { name: 'bonus_4', score: 1, chance: 0.2 },
    { name: 'coin', coins: 10, chance: 0.4 },
    // {name: "heart", lifes: 1, isHeart: true}
  ],
  weight: [
    { value: 'bonus', weight: 8 },
    { value: 'booster', weight: 2 },
  ],
  boostersWeight: [
    { value: { name: 'jetpack' }, weight: 1 },
    { value: { name: 'spring' }, weight: 1 },
  ],
  bonus: { scaleMultiplier: 0.08 },
  booster: { scaleMultiplier: 0.08 },
  gameWidth: 800,
  acceleration: 0.4,
  deceleration: 0.5,
  gravity: 0.5,
  maxGravity: 0.5,
  jumpForce: 22,
  maxJumpForce: 22,
  platformOffset: 750,
  difficulty: 13,
  platformOffsetRange: 0.3,
  platformBreakJumpCount: 9999999999,
  maxScore: 99999999999,
  playerCollideWidth: 0.3,
  platformSpeed: 1,
  probabilityDistributions: [],
  deadDistance: 300,
  groundSplash: {
    count: 10,
    width: 3.2,
    tapRadius: 1,
    animated: { radius: 75, randomFactor: 1.5 },
    circleRange: -Math.PI,
    time: { min: 0.3, max: 0.6 },
    ease: 'linear',
    colors: [0x0a4500, 0xf1a91d, 0xffffff],
  },
  bonusSplash: {
    count: 10,
    width: 20,
    tapRadius: 0,
    animated: { radius: 75, randomFactor: 1.1 },
    circleRange: 2 * Math.PI,
    time: { min: 0.5, max: 1 },
    ease: 'sine.inOut',
  },
  boostersScaleMultipliersFormMe: {
    spring: 0.05,
    jetpack: 0.09,
  },
}

export const infinityLevel = {
  level: 1,
  maxScore: Infinity,
  modules: [
    {
      platforms: 10,
      points: 4,
      bonusRepeat: 1,
      distributions: [
        { type: 1, probability: 1 },
        { type: 2, probability: 0 },
        { type: 3, probability: 0 },
      ],
    },
  ],
}

export const levels = [
  {
    level: 1,
    maxScore: 20,
    modules: [
      { platforms: 10, points: 10, bonusRepeat: 1, distributions: [{ type: 1, probability: 1 }] },
    ],
  },
  {
    level: 2,
    maxScore: 20,
    modules: [
      { platforms: 10, points: 10, bonusRepeat: 1, distributions: [{ type: 1, probability: 1 }] },
    ],
  },
  {
    level: 3,
    maxScore: 20,
    modules: [
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.9 },
          { type: 2, probability: 0.1 },
        ],
      },
    ],
  },
  {
    level: 4,
    maxScore: 25,
    modules: [
      { platforms: 10, points: 5, bonusRepeat: 2, distributions: [{ type: 1, probability: 1 }] },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 2, probability: 0.3 },
        ],
      },
    ],
  },
  {
    level: 5,
    maxScore: 25,
    modules: [
      { platforms: 10, points: 5, bonusRepeat: 2, distributions: [{ type: 1, probability: 1 }] },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 1, probability: 0.6 },
          { type: 2, probability: 0.4 },
        ],
      },
    ],
  },
  {
    level: 6,
    maxScore: 25,
    modules: [
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 2, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.5 },
        ],
      },
    ],
  },
  {
    level: 7,
    maxScore: 25,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 2, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.9 },
          { type: 3, probability: 0.1 },
        ],
      },
    ],
  },
  {
    level: 8,
    maxScore: 25,
    modules: [
      {
        platforms: 10,
        points: 2,
        bonusRepeat: 5,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.4 },
          { type: 3, probability: 0.1 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.8 },
          { type: 3, probability: 0.2 },
        ],
      },
    ],
  },
  {
    level: 9,
    maxScore: 25,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.6 },
          { type: 2, probability: 0.4 },
        ],
      },
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.2 },
          { type: 3, probability: 0.3 },
        ],
      },
    ],
  },
  {
    level: 10,
    maxScore: 25,
    modules: [
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.4 },
          { type: 3, probability: 0.1 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.5 },
        ],
      },
    ],
  },
  {
    level: 11,
    maxScore: 25,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.6 },
          { type: 2, probability: 0.4 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 3, probability: 0.3 },
        ],
      },
    ],
  },
  {
    level: 12,
    maxScore: 25,
    modules: [
      {
        platforms: 10,
        points: 2,
        bonusRepeat: 5,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.4 },
          { type: 3, probability: 0.1 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.8 },
          { type: 3, probability: 0.2 },
        ],
      },
    ],
  },
  {
    level: 13,
    maxScore: 10,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.6 },
          { type: 2, probability: 0.3 },
          { type: 3, probability: 0.1 },
        ],
      },
      {
        platforms: 10,
        points: 2,
        bonusRepeat: 5,
        distributions: [
          { type: 1, probability: 0.4 },
          { type: 2, probability: 0.4 },
          { type: 3, probability: 0.2 },
        ],
      },
    ],
  },
  {
    level: 14,
    maxScore: 10,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.8 },
          { type: 2, probability: 0.2 },
        ],
      },
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.6 },
          { type: 2, probability: 0.3 },
          { type: 3, probability: 0.1 },
        ],
      },
      { platforms: 10, points: 10, bonusRepeat: 1, distributions: [{ type: 2, probability: 1 }] },
    ],
  },
  {
    level: 15,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.2 },
          { type: 3, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.6 },
          { type: 2, probability: 0.4 },
        ],
      },
    ],
  },
  {
    level: 16,
    maxScore: 10,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.4 },
          { type: 3, probability: 0.1 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 2, probability: 0.6 },
          { type: 3, probability: 0.4 },
        ],
      },
    ],
  },
  {
    level: 17,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.4 },
          { type: 2, probability: 0.4 },
          { type: 3, probability: 0.2 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 2, probability: 0.5 },
          { type: 3, probability: 0.5 },
        ],
      },
    ],
  },
  {
    level: 18,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 1, probability: 0.2 },
          { type: 2, probability: 0.6 },
          { type: 3, probability: 0.2 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 2, probability: 0.7 },
          { type: 3, probability: 0.3 },
        ],
      },
    ],
  },
  {
    level: 19,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.6 },
          { type: 2, probability: 0.4 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 3, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 1, probability: 0.2 },
          { type: 3, probability: 0.8 },
        ],
      },
    ],
  },
  {
    level: 20,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.3 },
          { type: 2, probability: 0.4 },
          { type: 3, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 3, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 2, probability: 0.5 },
          { type: 3, probability: 0.5 },
        ],
      },
    ],
  },
  {
    level: 21,
    maxScore: 20,
    modules: [
      { platforms: 5, points: 5, bonusRepeat: 1, distributions: [{ type: 1, probability: 1 }] },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 2, probability: 0.7 },
          { type: 3, probability: 0.3 },
        ],
      },
      { platforms: 10, points: 10, bonusRepeat: 1, distributions: [{ type: 3, probability: 1 }] },
    ],
  },
  {
    level: 22,
    maxScore: 20,
    modules: [
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 1, probability: 0.4 },
          { type: 2, probability: 0.3 },
          { type: 3, probability: 0.3 },
        ],
      },
    ],
  },
  {
    level: 23,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.3 },
          { type: 2, probability: 0.4 },
          { type: 3, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 2, probability: 0.7 },
          { type: 3, probability: 0.3 },
        ],
      },
      { platforms: 10, points: 10, bonusRepeat: 1, distributions: [{ type: 2, probability: 1 }] },
    ],
  },
  {
    level: 24,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 2,
        bonusRepeat: 5,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 2, probability: 0.2 },
          { type: 3, probability: 0.1 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 3, probability: 0.3 },
        ],
      },
      { platforms: 10, points: 10, bonusRepeat: 1, distributions: [{ type: 2, probability: 1 }] },
    ],
  },
  {
    level: 25,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.1 },
          { type: 3, probability: 0.4 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 2, probability: 0.7 },
          { type: 3, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 2, probability: 0.3 },
        ],
      },
    ],
  },
  {
    level: 26,
    maxScore: 20,
    modules: [
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 1, probability: 0.3 },
          { type: 2, probability: 0.3 },
          { type: 3, probability: 0.4 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 2, probability: 0.7 },
          { type: 3, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.5 },
        ],
      },
    ],
  },
  {
    level: 27,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.8 },
          { type: 3, probability: 0.2 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 2, probability: 0.5 },
          { type: 3, probability: 0.5 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.1 },
          { type: 2, probability: 0.3 },
          { type: 3, probability: 0.6 },
        ],
      },
    ],
  },
  {
    level: 28,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.6 },
          { type: 3, probability: 0.4 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.5 },
        ],
      },
      { platforms: 10, points: 10, bonusRepeat: 1, distributions: [{ type: 2, probability: 1 }] },
    ],
  },
  {
    level: 29,
    maxScore: 20,
    modules: [
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.5 },
          { type: 2, probability: 0.5 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 2, probability: 0.5 },
          { type: 3, probability: 0.5 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 1, probability: 0.2 },
          { type: 3, probability: 0.8 },
        ],
      },
    ],
  },
  {
    level: 30,
    maxScore: 15,
    modules: [
      {
        platforms: 10,
        points: 3,
        bonusRepeat: 3,
        distributions: [
          { type: 1, probability: 0.7 },
          { type: 2, probability: 0.3 },
        ],
      },
      {
        platforms: 10,
        points: 5,
        bonusRepeat: 2,
        distributions: [
          { type: 1, probability: 0.3 },
          { type: 2, probability: 0.7 },
        ],
      },
      {
        platforms: 10,
        points: 10,
        bonusRepeat: 1,
        distributions: [
          { type: 2, probability: 0.3 },
          { type: 3, probability: 0.7 },
        ],
      },
    ],
  },
]
// 5
export const modules = [
  {
    num: 1,
    platforms: 10,
    points: 10,
    bonusRepeat: 1,
    distributions: [{ type: 1, probability: 1 }],
  },
  {
    num: 2,
    platforms: 10,
    points: 5,
    bonusRepeat: 2,
    distributions: [
      { type: 1, probability: 0.9 },
      { type: 2, probability: 0.1 },
    ],
  },
  {
    num: 3,
    platforms: 10,
    points: 5,
    bonusRepeat: 2,
    distributions: [{ type: 1, probability: 1 }],
  },
  {
    num: 4,
    platforms: 10,
    points: 5,
    bonusRepeat: 2,
    distributions: [
      { type: 1, probability: 0.7 },
      { type: 2, probability: 0.3 },
    ],
  },
  {
    num: 5,
    platforms: 10,
    points: 10,
    bonusRepeat: 1,
    distributions: [
      { type: 1, probability: 0.6 },
      { type: 2, probability: 0.4 },
    ],
  },
  {
    num: 6,
    platforms: 10,
    points: 10,
    bonusRepeat: Math.floor(30 / 3),
    distributions: [
      { type: 1, probability: 0.25 },
      { type: 2, probability: 0.5 },
      { type: 3, probability: 0.25 },
    ],
  },
  {
    platforms: 30,
    points: 3,
    bonusRepeat: Math.floor(30 / 3),
    distributions: [
      { type: 2, probability: 0.7 },
      { type: 3, probability: 0.3 },
    ],
  },
  {
    platforms: 30,
    points: 3,
    bonusRepeat: Math.floor(30 / 3),
    distributions: [
      { type: 2, probability: 0.5 },
      { type: 3, probability: 0.5 },
    ],
  },
  {
    platforms: 30,
    points: 3,
    bonusRepeat: Math.floor(30 / 3),
    distributions: [
      { type: 2, probability: 0.25 },
      { type: 3, probability: 0.75 },
    ],
  },
  {
    platforms: 30,
    points: 3,
    bonusRepeat: Math.floor(30 / 3),
    distributions: [
      { type: 2, probability: 0.1 },
      { type: 3, probability: 0.9 },
    ],
  },
]

export const idle = 60_000
export const DEBUG = false
